import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/BillableEventsService';

// FNP-533: single-record read for the detail view. Read-only — no create,
// update, or delete mutations (the metering pipeline owns the lifecycle).
export const useBillableEvent = (billableEventId?: string) => {

    const billableEventQuery = useQuery({
        // FNP-1879: under the module's ['billableEvents'] root, so the invalidation Requeue and
        // Write off already issue refreshes an open detail view too.
        queryKey: ['billableEvents', 'detail', billableEventId],
        queryFn: () => fetch(billableEventId!),
        enabled: !!billableEventId
    });

    return {
        record: billableEventQuery.data,
        loading: billableEventQuery.isLoading,
        // Surface error + fetched-but-empty so the detail page can show a
        // "not found" state instead of hanging on the loader forever when an id
        // doesn't resolve (e.g. a malformed/encoded id, or a deleted record).
        isError: billableEventQuery.isError,
        notFound: billableEventQuery.isFetched && !billableEventQuery.data,
        fetchRecord: billableEventQuery.refetch,
    };
};
